var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.searchBar)?_c('search-bar-filter',{attrs:{"featureConfig":_vm.searchBar}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }